// Field Names from Firestore:  Game doc
export const AUTHOR_ID     = 'authorId';
export const AUTHOR_NAME   = 'authorName';
export const BOUNDS        = 'bounding_box';
export const CLUES         = 'clues';
export const CREATED       = 'created';
export const DIFFICULTY    = 'difficultyLevel';
export const DURATION      = 'duration';
export const EVENT_DATE    = 'eventDate';
export const INTRO         = 'intro';
export const LAST_MODIFIED = 'lastModified';
export const LAST_PLAYED   = 'lastPlayed';
export const LOC_NAME      = 'locationName';
export const PUBLIC        = 'isPublic';
export const GAME_TYPE     = 'gameType';
export const RANDOM_CLUES  = 'randomizeClues';
export const TREASURE_TYPE = 'treasureType';
export const TREASURE_DESCRIPTION = 'treasureDescription';
export const PUBLISHED     = 'isPublished';
export const SHORT_TITLE   = 'shortTitle';
export const TITLE         = 'title';
export const WIN_CODE      = 'winCode';
export const PICTURE       = 'hunt_picture';
export const PREMIUM       = 'isPremium';
export const TOTAL_PLAYED  = 'totalPlayed';
export const TOTAL_WON     = 'totalWon';

// Field Names from Firestore:  Gamestate doc
export const CLUE_DUR_REMAINING = 'clueDurationRemaining';
export const CLUE_START_TIME = 'clueStartTime';
export const CLUES_PRESENTED = 'cluesPresented';
export const CLUES_RELEASED  = 'cluesReleased';
export const GAME_RESULT     = 'gameResult';
export const GAME_STATUS     = 'gameStatus';
export const IS_PRIVATE      = 'isPrivate';                    // This is in the gameState doc.  Do NOT user gor game.
export const STARTED_AT      = 'startedAt';
export const START_TIME      = 'startTime';

export const GAME_TYPE_CODE = 'code-to-code';
export const GAME_TYPE_TIME = 'time-based';
export const GAME_TYPE_MIXED = 'mixed';

export const GAME_STATUS_COMPLETED = 'COMPLETED';
export const GAME_STATUS_PAUSED = 'PAUSED';
export const GAME_STATUS_RUNNING = 'RUNNING';

export const TREASURE_TYPE_NATURAL = 'natural';
export const TREASURE_TYPE_MANMADE = 'man-made';
export const TREASURE_TYPE_PLACED = 'placed';
export const TREASURE_TYPE_SIGN = 'sign';
export const TREASURE_TYPE_CACHE = 'cache';
export const TREASURE_TYPE_TREASURE = 'treasure';

export const DIFFICULTY_KIDS = "kids";
export const DIFFICULTY_PLAIN_SIGHT = "plain_sight";
export const DIFFICULTY_EASY = "easy";
export const DIFFICULTY_MODERATE = "moderate";
export const DIFFICULTY_GENIUS = "genius";




// WEBPACK FOOTER //
// ./src/constants/Game.js